import React, {useEffect} from "react"
import {compose} from "redux"
import {useTranslation} from "react-i18next"
import {RouteComponentProps} from "react-router"
import {Container} from "@material-ui/core"

// Components
import DoctorStatsContainer from "../DoctorStatsContainer"
import AvailableRecordTable from "../AvailableRecordTable"
import InProgressSection from "../InProgressSection"
import Button from "../../../../components/Button"

// Constants
import {AppRoute} from "../../../routing/constants"

// HOCs
import withUser, {WithUserProps} from "../../../auth/hoc/withUser"
import withWSConnection, {WithWSConnectionProps} from "../../../ws/hoc/withWSConnection"

// Utils
import Utils from "../../../../utils/Utils"

// Styles
import useStyles from "./styles"

/**
 * @param props
 */
function HomePage(props: RouteComponentProps & WithUserProps & WithWSConnectionProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {history, user, openAvailableRecordsWSConnectionAsync, closeAvailableRecordsWSConnection} = props;
    const isDoctor = false === Utils.isCompanyMaster(user)

    function handleStartButtonClick() {
        history.push(AppRoute.Record);
    }

    useEffect(() => {
        openAvailableRecordsWSConnectionAsync()

        return () => {
            closeAvailableRecordsWSConnection()
        }
    }, [openAvailableRecordsWSConnectionAsync, closeAvailableRecordsWSConnection])

    return (
        <Container maxWidth="lg" className={styles.container}>
            <div>
                <h2 className={styles.title}>
                    {t("stats.title")}
                </h2>
                <DoctorStatsContainer/>
                <InProgressSection/>
                {isDoctor && (
                    <React.Fragment>
                        <h2 className={styles.title}>
                            {t("stats.available_records_table.title")}
                        </h2>
                        <AvailableRecordTable/>
                    </React.Fragment>
                )}
            </div>
            {isDoctor && (
                <Container maxWidth="xs" className={styles.start_button_container}>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        className={styles.start_button}
                        label={t("records.start_button")}
                        onClick={handleStartButtonClick}
                    />
                </Container>
            )}
        </Container>
    )
}

export default compose(
    withUser,
    withWSConnection,
)(HomePage)
